import { Flex, Input, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGetAllCandidates } from "../../api/api.get";
import { ICandidate } from "../../types/types";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import { SortOrder } from "antd/es/table/interface";

export default function AdminCandidatesPage() {
  const { data: users } = useGetAllCandidates();
  const [rowData, setRowData] = useState<ICandidate[]>([]);

  const columns = [
    { title: "CID", dataIndex: "cid", key: "cid" },
    { title: "Email", dataIndex: "email", key: "email", width: 350 },
    { title: "Reg Key", dataIndex: "regkey", key: "regkey" },
    { title: "Username", dataIndex: "username", key: "username" },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text: string) => {
        return moment(text).format("YYYY-MM-DD hh:mm A");
      },
      sorter: (a: any, b: any) =>
        moment(a.created_at).isAfter(moment(b.created_at)) ? 1 : -1,
      sortDirections: ["descend" as SortOrder],
    },
  ];

  useEffect(() => {
    if (users) {
      setRowData(users);
    }
  }, [users]);

  return (
    <div className="body">
      <div className="my-20">
        <div className="flex justify-between px-6 py-4 w-full bg-gray-100 mb-10">
          <Link
            to="/home"
            className="flex items-center gap-2 hover:opacity-80 transition"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
            <span className="text-black font-bold">Back</span>
          </Link>
        </div>

        <div className="p-4">
          <div className="p-4">
            <Flex>
              <Typography.Title level={2}>Users</Typography.Title>

              <Input
                placeholder="Search by email"
                style={{ width: 300, marginLeft: "auto" }}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase();
                  const filteredData =
                    users?.filter((user) =>
                      user.email.toLowerCase().includes(value)
                    ) || [];
                  const data =
                    filteredData.filter((user) =>
                      user.email.toLowerCase().includes(value)
                    ) || [];
                  setRowData(data);
                }}
              />
            </Flex>
            <Table dataSource={rowData} columns={columns} />;
          </div>
        </div>
      </div>
    </div>
  );
}
